module.exports = __webpack_public_path__ + "static/media/equifaxfavicon.1164001b.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicons/equifaxfavicon.ico
// module id = 1128
// module chunks = 0